module.exports = __webpack_public_path__ + "static/media/facebook.9c9f9ed1.jpg";